import React, { useState } from 'react'
import { Box, Button, FormField, Text, TextInput } from 'grommet'
import { I18n, GlobalConfig, Constants } from 'galarm-config'
import { TaskManager } from 'galarm-shared'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import GalarmWebHeader from './GalarmWebHeader'

const EnterVerificationCodeScreen = ({
  phoneData,
  onAuthenticated,
  onBack
}) => {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')

  const { mobileNumber, countryCode, requestId } = phoneData

  const onVerifyCode = () => {
    setError('')

    if (!code.trim()) {
      setError(I18n.t('enterVerificationCodeForPremiumValidation'))
      return
    }

    GlobalConfig.showProgress({
      state: Constants.ProgressStates.IN_PROGRESS,
      message: I18n.t('verifyingCode'),
      closeable: false
    })
    TaskManager.addHttpsCloudTask('verifyAppCode', {
      requestId,
      code: code.trim(),
      mobileNumber,
      countryCode
    })
      .then(taskResult => {
        const uid = taskResult?.uid
        const email = taskResult?.email
        const name = taskResult?.name

        if (!uid) {
          GlobalConfig.dismissProgress()
          setError(
            I18n.t('unableToVerifyAppCode', { error: 'No UID returned' })
          )
          return
        }

        GlobalConfig.uid = uid

        return TaskManager.addHttpsCloudTask('generateAuthenticationToken', {
          uid,
          appSecret: GlobalConfig.appSecret
        }).then(authResult => {
          const authToken = authResult.result?.authToken
          const auth = getAuth()
          return signInWithCustomToken(auth, authToken).then(() => ({
            uid,
            email,
            name
          }))
        })
      })
      .then(result => {
        if (!result) {
          // No need to show an error here, as the error would have been shown in the previous step
          return
        }

        GlobalConfig.dismissProgress()
        onAuthenticated(result)
      })
      .catch(error => {
        GlobalConfig.dismissProgress()
        setError(
          I18n.t('unableToVerifyAppCode', {
            error: error.error || error.message || ''
          })
        )
      })
  }

  return (
    <Box fill>
      <GalarmWebHeader />

      {error ? (
        <Box
          pad={{ horizontal: 'large', vertical: 'small' }}
          background="status-error">
          <Text color="white" size="small" textAlign="center">
            {error}
          </Text>
        </Box>
      ) : null}

      <Box flex overflow="auto" align="center" justify="start" pad="large">
        <Box width="large" gap="medium" flex={{ shrink: 0 }}>
          <Box align="center" gap="small">
            <Text size="xlarge" weight="bold">
              {I18n.t('enterVerificationCodeForPremium')}
            </Text>
            <Text
              textAlign="center"
              color="dark-4"
              style={{ whiteSpace: 'pre-line' }}>
              {I18n.t('verificationCodeForPremiumDescription')}
            </Text>
          </Box>

          <FormField label={I18n.t('verificationCode')}>
            <TextInput
              placeholder="1234"
              value={code}
              onChange={e => setCode(e.target.value)}
              type="text"
              inputMode="numeric"
              maxLength={10}
            />
          </FormField>

          <Box
            direction="row"
            align="center"
            gap="small"
            width="medium"
            alignSelf="center">
            <Button
              primary
              pad="small"
              fill="horizontal"
              label={<Text color="white">{I18n.t('verifyCode')}</Text>}
              onClick={onVerifyCode}
            />
            <Button
              pad="small"
              fill="horizontal"
              label={I18n.t('back')}
              onClick={onBack}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EnterVerificationCodeScreen
